


















































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

import Play from "./detail_play.vue";
import Order from "./detail_order.vue";
import Other from "./detail_other.vue";
import Player from "./detail_player.vue";
import AiPlayer from "./detail_ai_player.vue";
import Contact from "./detail_contact.vue";
import Bill from "./detail_bill.vue";
import UserBalance from "./detail_balance.vue";
import Vip from "./detail_vip.vue";
import Activity from "./detail_activity.vue";
import Balance from "./balance.vue";
import Coupon from "./detail_coupon.vue";

import FrozenMoney from "./frozenmoney.vue";

import Deposit from "./deposit.vue";

@Component({
  components: {
    Play,
    Order,
    Other,
    Player,
    AiPlayer,
    Contact,
    Bill,
    Vip,
    Activity,
    Balance,
    FrozenMoney,
    Coupon,
    Deposit,
    UserBalance
  }
})
export default class extends Mixins(MyForm) {
  balanceModalVisible = false;

  frozenMoneyModalVisible = false;

  is_master = false;
  is_nosms = false;

  field = "";

  t = 0;

  cate = 0;

  showNewUserDetailModal(userId: number) {
    console.log(userId);
    this.hideGlobalUserDetailModal();

    this.$nextTick(() => {
      this.showGlobalUserDetailModal(userId);
    });
  }

  showBalanceModal(id: number, cate: number) {
    this.editId = id;
    this.cate = cate;
    this.balanceModalVisible = true;
  }

  hideBalanceModal() {
    this.balanceModalVisible = false;
  }

  showFrozenMoneyModal(field: string, t: number) {
    this.field = field;
    this.t = t;
    this.frozenMoneyModalVisible = true;
  }

  hideFrozenMoneyModal() {
    this.frozenMoneyModalVisible = false;
    // this.loadDetail();
    // this.handleCancel();
  }

  changeIsMaster(val: boolean) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要设置为${val ? "内部人员" : "一般用户"}`,
      onOk: () => {
        this.$store.dispatch("users/setIsMaster", {
          user_id: this.editId,
          status: val ? 1 : 0
        });
        this.$message.success("操作成功");
        this.is_master = val;
      },
      onCancel: () => {
        // this.phone_status = val ? false : val;
      }
    });
  }

  changeIsNoSms(val: boolean) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要设为${val ? "屏蔽短信" : "接收短信"}`,
      onOk: () => {
        this.$store.dispatch("users/setIsNoSms", {
          user_id: this.editId,
          status: val ? 1 : 0
        });
        this.$message.success("操作成功");
        this.is_nosms = val;
      },
      onCancel: () => {
        // this.phone_status = val ? false : val;
      }
    });
  }

  async loadDetail() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("users/detail", {
      id: this.editId
    });
    if (res && res.Data) {
      this.formData = res.Data;
      this.is_master = res.Data.is_master > 0;
      this.is_nosms = res.Data.sms_notice ==='0';
      if (res.Data.face_photo) {
        this.getImageUrl(res.Data.face_photo).then((url: any) => {
          this.formData.face_photo = url;
        });
      }
    }
    this.spinLoading = false;
  }

  mounted() {
    this.loadDetail();
  }

  hideDeposit() {
    this.loadDetail();
  }
}
